module.exports = __webpack_public_path__ + "jo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/jo.svg
// module id = 627
// module chunks = 0